import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import { ref, withDefaults, onMounted } from 'vue';
import events from '@/events';
import LzIcon from './LzIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LzAccordion',
  props: {
    title: { default: '' },
    group: { default: '' },
    open: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }) {

const props = __props;



const visible = ref(props.open);
const ready = ref(false);

events.$on('accordion-open', onAccordionOpened);

onMounted(() => {
    ready.value = true;
});

function onAccordionOpened(group: string) {
    if (!props.group || props.group === '') {
        return;
    }
    if (props.group === group) {
        visible.value = false;
    }
}

function toggle() {
    if (!visible.value) {
        events.$emit('accordion-open', props.group);
    }
    visible.value = !visible.value;
    emit('toggle', visible.value);
}

return (_ctx: any,_cache: any) => {
  const _component_collapse_transition = _resolveComponent("collapse-transition")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative", { 'pointer-events-none': _ctx.disabled }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["border-b lg:mx-0 lg:px-0", { 'border-gray-400/50': _ctx.small && !visible.value }])
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["flex w-full justify-between items-center", [{ 'opacity-50': _ctx.disabled }, _ctx.small ? 'pt-6 pb-2 text-md' : 'text-xl py-8 font-bold lg:text-2xl']]),
        onClick: toggle
      }, [
        _renderSlot(_ctx.$slots, "title", { open: visible.value }, () => [
          _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
        ]),
        (_ctx.small)
          ? (_openBlock(), _createBlock(LzIcon, {
              key: 0,
              name: "accordion-chevron",
              class: _normalizeClass([[visible.value ? (_ctx.small ? 'rotate-0' : '-rotate-90') : (_ctx.small ? 'rotate-180' : 'rotate-90')], "shrink-0 transition-transform fill-current h-4 w-4 stroke-current"])
            }, null, 8, ["class"]))
          : (_openBlock(), _createBlock(LzIcon, {
              key: 1,
              name: visible.value ? 'minus' : 'plus',
              class: "shrink-0 transition-transform fill-current h-6 w-6"
            }, null, 8, ["name"]))
      ], 2),
      _withDirectives(_createVNode(_component_collapse_transition, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass({ 'pb-8': !_ctx.small })
          }, [
            _renderSlot(_ctx.$slots, "default", { ready: ready.value })
          ], 2)
        ]),
        _: 3
      }, 512), [
        [_vShow, visible.value]
      ])
    ], 2)
  ], 2))
}
}

})